module.exports = Jsw.skinUrl + "/images/disco-mode/dancers.gif?8ba854d14fa3d6c5dcd98bb5d8c3b9bc";